import { render, staticRenderFns } from "./DeleteAccountListCard.vue?vue&type=template&id=a0243262&"
import script from "./DeleteAccountListCard.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports